import type { FaireProductEntity } from "../../entity_types/product";

export const p_6bqyrkmnpc: FaireProductEntity = {
  token: "p_6bqyrkmnpc",
  type: "product",
  name: "RELIEF | Adult (Ages 16+)",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/f0ed9b453c94cb21e3778fafd8dc1bcb72c4087540d4f012789a38374fa6cd18.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1009f1a78b591bcec658e4e8131b14789187373b622eaec67f3f61927b5bfde.png",
  ],
  priceDollars: 20.3,
  description:
    'Inflammation is found at the root of most pain, so we developed a formula that combines the most anti-inflammatory agents into one bottle. Now with a cost effective 4 oz refill size!\n\nTO USE: Take 1-2 servings orally as needed for pain or use daily to combat inflammation.\n\n⚠️ Please Note: Curcumin naturally provides the same effects as blood pressure and diabetes medications. Anyone with these conditions should take extra precaution. We recommend checking with your doctor before making any changes to your dietary routine. Children’s Relief is recommended to use during pregnancy due to willow bark in the adult version.\n\nINGREDIENTS: ORGANIC LIPOSOMAL CURCUMIN, ORGANIC VEGETABLE GLYCERIN, ORGANIC LIPOSOMAL WILLOW BARK, ORGANIC LIPOSOMAL GINGER, ORGANIC NON-GMO SUNFLOWER LECITHIN, ORGANIC BLACK PEPPER, 100% PURE THERAPEUTIC GRADE ESSENTIAL OIL: COPAIBA.\n\nDimension 2 oz, 1.51" x 3.685" x 1.51".',
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:02.249Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
